// TasteWeaverDebugger.js
// 画像生成イベントをデバッグするためのユーティリティ

/**
 * TasteWeaverデバッガーをセットアップする
 * フロントエンドで画像生成の問題をデバッグするのに役立ちます
 */
export function setupImageDebugger() {
  // グローバルデバッグ変数を定義
  window.__DEBUG = {
    eventsCaptured: [],
    lastImageData: null
  };

  // 緊急イベントリスナーを追加
  window.addEventListener('image_generated', function(event) {
    console.log('緊急リスナー: 画像生成イベントを捕捉しました', event);
    
    // データを保存
    window.__DEBUG.eventsCaptured.push({
      time: new Date().toISOString(),
      event: 'image_generated',
      detail: event.detail
    });
    
    // 画像データを抽出
    const imageData = event.detail?.generatedImage || event.detail?.imageData || event.detail;
    if (imageData) {
      window.__DEBUG.lastImageData = imageData;
      console.log('緊急リスナー: 画像データ', imageData);
      
      // デバッグモードの場合のみ緊急表示を行う
      const isDebugMode = window.location.search.includes('debug=true');
      if (!isDebugMode) {
        console.log('緊急リスナー: デバッグモードではないため、ポップアップ表示をスキップします');
        return;
      }
      
      // 緊急表示機能
      try {
        // バックエンドURLを定義
        const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
        
        // URLを生成 - localPathを優先して使用
        let imageUrl = null;
        if (imageData.localPath) {
          imageUrl = `${backendUrl}${imageData.localPath.startsWith('/') ? '' : '/'}${imageData.localPath}`;
        } else if (imageData.imageUrl) {
          imageUrl = imageData.imageUrl;
        } else if (imageData.url) {
          // Azure Blobからの直接URLは避け、バックエンドプロキシを使う
          if (imageData.url.includes('blob.core.windows.net')) {
            console.warn('Azure Blobからの直接URLは使用しません。バックエンドキャッシュを確認してください。');
          } else {
            imageUrl = imageData.url;
          }
        }
        
        if (imageUrl) {
          console.log('緊急リスナー: 画像URL = ', imageUrl);
          
          // 画像要素を作成
          const img = document.createElement('img');
          img.src = imageUrl;
          img.style.maxWidth = '80%';
          img.style.border = '3px solid red';
          img.style.borderRadius = '8px';
          
          // コンテナを作成
          const container = document.createElement('div');
          container.id = 'debug-image-container';
          container.style.position = 'fixed';
          container.style.top = '20px';
          container.style.right = '20px';
          container.style.backgroundColor = '#ffeeee';
          container.style.padding = '10px';
          container.style.borderRadius = '8px';
          container.style.zIndex = '9999';
          container.style.boxShadow = '0 0 10px rgba(0,0,0,0.5)';
          
          // タイトルを追加
          const title = document.createElement('h3');
          title.textContent = 'デバッグ: 生成された画像';
          title.style.margin = '0 0 10px 0';
          title.style.color = '#cc0000';
          
          // 閉じるボタン
          const closeBtn = document.createElement('button');
          closeBtn.textContent = '閉じる';
          closeBtn.style.marginTop = '10px';
          closeBtn.onclick = function() { container.remove(); };
          
          // 要素を組み立て
          container.appendChild(title);
          container.appendChild(img);
          container.appendChild(closeBtn);
          
          // 既存のコンテナを削除
          const existingContainer = document.getElementById('debug-image-container');
          if (existingContainer) existingContainer.remove();
          
          // ページに追加
          document.body.appendChild(container);
          
          console.log('緊急リスナー: デバッグ画像を表示しました');
        }
      } catch (error) {
        console.error('緊急リスナー: エラー発生', error);
      }
    }
  });

  console.log('緊急デバッグリスナーが登録されました。デバッグモードで画像生成を試すには ?debug=true を追加してください。');
  return true;
}

// エクスポート - コンソールから直接コールできるようにする
window.setupTasteWeaverDebugger = setupImageDebugger; 